import cn from 'classnames';
import styles from './Code.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
};

/**
 * {@link Code} is intended to be used to indicate code inline with other text.
 */
export function Code({ children, className }: Props) {
  return <code className={cn(styles.Code, className)}>{children}</code>;
}
